import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TodayModeService {
  readonly todayMode: boolean = false;

  readonly todayMode$ = new BehaviorSubject<boolean>(this.todayMode);

  constructor() {
    const todayMode = localStorage.getItem('todayMode');
    if (todayMode) {
      this.todayMode$.next(todayMode === 'true');
    }
  }

  changeTodayMode() {
    this.todayMode$.next(!this.todayMode$.value);
    localStorage.setItem('todayMode', this.todayMode$.value.toString());
  }
}
